/* eslint-disable @typescript-eslint/no-explicit-any */
export function callBoth() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var lastResult;
        for (var _a = 0, fns_1 = fns; _a < fns_1.length; _a++) {
            var fn = fns_1[_a];
            if (typeof fn === 'function') {
                lastResult = fn.apply(void 0, args);
            }
        }
        return lastResult;
    });
}
